import { RouterName } from '@/enums/router-name'
import { useOtpStore } from '@/stores/use-otp-store'
import { useStorage } from '~library/composables'
import { LocalStorage } from '~library/enums'
import { useRouterUtils } from './use-router-utils'

export function useReload() {
  const { getStorageKey } = useStorage()
  const { routerName } = useRouterUtils()
  const { defaultOtpData } = useOtpStore()

  const isBindingPage = computed(() => {
    return [
      RouterName.COMPANY_EMPLOYEE,
      RouterName.COMPANY_EMPLOYEE_BIND,
      RouterName.COMPANY_EMPLOYEE_BIND_CHANGE,
      RouterName.COMPANY_EMPLOYEE_BIND_SUCCESS
    ].includes(routerName.value)
  })

  const storageListenerReload = () => {
    addEventListener('storage', (event) => {
      if (isBindingPage.value) {
        return
      }

      if (
        event.key === getStorageKey(LocalStorage.USER_PROFILE) ||
        event.key === getStorageKey(LocalStorage.USER_PROFILE_IDENTITY)
      ) {
        defaultOtpData()
        window.location.reload()
      }
    })
  }

  return { storageListenerReload }
}
